import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { WorkshopJobEventBase } from '../../models/workshop-job-event';

@Injectable()
export class WorkshopJobEventsService {
  private resourcePrefix = 'workshop-jobs';
  private resourceEndpoint = 'events';

  constructor(private http: ApiClient) {}

  public getForJob(id: number) {
    return this.http.get<WorkshopJobEventBase<any>[]>(
      `${this.resourcePrefix}/${id}/${this.resourceEndpoint}`
    );
  }

  public addEvent(jobId: number, event: Partial<WorkshopJobEventBase<any>>) {
    return this.http.post<WorkshopJobEventBase<any>>(
      `${this.resourcePrefix}/${jobId}/${this.resourceEndpoint}`,
      event
    );
  }

  public updateEvent(
    jobId: number,
    eventId: number,
    event: Partial<WorkshopJobEventBase<any>>
  ) {
    return this.http.put<WorkshopJobEventBase<any>>(
      `${this.resourcePrefix}/${jobId}/${this.resourceEndpoint}/${eventId}`,
      event
    );
  }
}
